import React, { useEffect, useState } from 'react'
import  './MenuManagement.scss'
import { RawParentsCategorys, MenuCategory} from '../../../../types';
import {removeMenuCategoryFromMenu,addMenuCategoryToMenu, getMenusByLocalId } from '../../../../../../../../crud/menu_api/menus';
import Modal from 'react-bootstrap/Modal';
import { Button, Dropdown } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import {toast} from 'react-toastify';
import { FaTrash } from 'react-icons/fa6';
import { FaPlus } from 'react-icons/fa6';


interface Props {
  category?: RawParentsCategorys;
  show: boolean;
  onClose: () => void;
}



const ModalMenuCategory: React.FC<Props> = ({ category, show, onClose }) => {
  const [menus, setMenus] = useState<{ id: number; name: string }[]>([]);
  const [selectedMenuId, setSelectedMenuId] = useState<number | null>(null);
  const [categoryMenus, setCategoryMenus] = useState<any[]>(category?.menus || []);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && category) {
      setCategoryMenus(category.menus || []);
      const userContext = localStorage.getItem('user');
      const localId = userContext ? JSON.parse(userContext).local_id : 0;
      getMenusByLocalId(localId)
        .then((response) => {
          const transformedMenus = response.data.map((menu: any) => ({
            id: menu.menu_id,
            name: menu.menu_name,
          }));
          setMenus(transformedMenus);
        })
        .catch(() => {
          setMenus([]);
        });
    }
  }, [show, category]);

  const handleAddMenu = async () => {
    if (!selectedMenuId || !category) return;
    setLoading(true);
    toast.info('Agregando menú a la categoría...');
    try {
      await addMenuCategoryToMenu(selectedMenuId, category.category_id);
      const addedMenu = menus.find(menu => menu.id === selectedMenuId);
      if (addedMenu) {
        setCategoryMenus(prev => ([...prev, { menu_id: addedMenu.id, menu_name: addedMenu.name }]));
      }
      setSelectedMenuId(null);
      toast.success('Menú agregado correctamente.');
    } catch (error) {
      toast.error('Ocurrió un error al agregar el menú.');
    }
    setLoading(false);
  };

  const handleRemoveMenu = async (menuId: number) => {
    if (!category) return;
    setLoading(true);
    toast.info('Eliminando menú de la categoría...');
    try {
      await removeMenuCategoryFromMenu(menuId, category.category_id);
      setCategoryMenus(prev => prev.filter(menu => menu.menu_id !== menuId));
      toast.success('Menú eliminado correctamente.');
    } catch (error) {
      toast.error('Ocurrió un error al eliminar el menú.');
    }
    setLoading(false);
  };

  if (!category) return <div>No se encontró la categoría.</div>;
  return (
    <Modal show={show} onHide={onClose} className="mp-modal-menu-category">
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">Menú de la categoría: {category.category_name}</Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={onClose}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className="mp-modal-menu-category-body">
          <h5>Menús disponibles:</h5>
          {categoryMenus.length > 0 ? (
            categoryMenus.map((menu) => (
              <div key={menu.menu_id} className="mp-menu-item">
                <span>{menu.menu_name}</span>
                <Button
                  variant='none'
                  disabled={loading}
                  className="mp-menu-remove-btn"
                  onClick={() => handleRemoveMenu(menu.menu_id)}
                >
                  <FaTrash />
                </Button>
              </div>
            ))
          ) : (
            <p>No hay menús asociados a esta categoría.</p>
          )}
          <hr />
          <div className="mp-menu-add-section">
            <h5>Agregar menú a la categoría:</h5>
            <div className="mp-menu-selection-row">
              {menus
                .filter(menu => !categoryMenus.some(catMenu => catMenu.menu_id === menu.id))
                .map((menu) => {
                  const isSelected = selectedMenuId === menu.id;
                  return (
                    <div
                      key={menu.id}
                      className={`menu-option${isSelected ? ' selected' : ''}`}
                      onClick={() => setSelectedMenuId(menu.id)}
                    >
                      <span className="menu-name">{menu.name}</span>
                      <div className="menu-indicator"></div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="form-modal-footer-custom">
          <Button variant="secondary" className="form-button-cancel" onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button
            className='form-button-create mp-menu-add-btn'
            variant='primary'
            onClick={handleAddMenu}
            disabled={loading || !selectedMenuId}
          >
           Confirmar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalMenuCategory